import React, { useMemo } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useTheme } from '@mui/material/styles';
import { capitalizeFirstLetter } from '../util/helpers';

function LineChart({ data, dataKey, height = 350 }) {
  const theme = useTheme();

  const config = useMemo(() => {
    const seriesData = data[0].map(item => item[dataKey]);
    const labels = data[1];
    const color = theme.palette.secondary.main;

    return {
      series: [{ name: capitalizeFirstLetter(dataKey), data: seriesData }],
      options: {
        colors: [color],
        chart: {
          type: 'area',
          height,
          zoom: { enabled: false },
          toolbar: { show: true, tools: { download: true, selection: false, zoom: false, zoomin: false, zoomout: false, pan: false, reset: false } },
          fontFamily: 'inherit',
          animations: { enabled: true, easing: 'easeinout', speed: 800, animateGradually: { enabled: true, delay: 150 } },
          dropShadow: { enabled: true, top: 3, left: 0, blur: 6, color, opacity: 0.15 },
          offsetX: 0,
          offsetY: 0,
        },
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth', width: 3 },
        fill: {
          type: 'gradient',
          gradient: { shadeIntensity: 1, opacityFrom: 0.45, opacityTo: 0.02, stops: [0, 90, 100] },
        },
        labels,
        xaxis: {
          type: 'datetime',
          axisBorder: { show: false },
          axisTicks: { show: false },
          labels: { style: { colors: '#94a3b8', fontSize: '12px', fontWeight: 500 } },
        },
        yaxis: {
          tickAmount: 5,
          labels: {
            style: { colors: '#94a3b8', fontSize: '12px', fontWeight: 500 },
            formatter: (val) => (val != null && val !== '') ? Number(val).toLocaleString() : '',
          },
        },
        grid: {
          borderColor: '#f1f5f9',
          strokeDashArray: 4,
          padding: { left: 10, right: 10, top: 10, bottom: 8 },
        },
        markers: { size: 0, hover: { size: 6, sizeOffset: 3 } },
        tooltip: {
          theme: 'light',
          style: { fontSize: '13px' },
          x: { format: 'MMM dd, yyyy' },
          y: { formatter: (val) => val?.toLocaleString() },
          marker: { show: true },
        },
      },
    };
  }, [data, dataKey, theme, height]);

  return (
    <ReactApexChart options={config.options} series={config.series} type="area" height={height} />
  );
}

export default LineChart;
